/* Black Opal: inventory-aware integration with Webyze collection swatches.
   Runs after the theme's final loadSwatchesCollection definition. */
(function () {
  'use strict';

  if (typeof window.loadSwatchesCollection !== 'function') return;

  const originalLoadSwatches = window.loadSwatchesCollection;
  const configurations = new Map();
  const originalButtonHTML = new WeakMap();
  let decorationQueued = false;

  function getVariants(configuration, shade) {
    const index = Number(configuration.index) || 0;
    return configuration.product.variants.filter(function (variant) {
      return variant.options && variant.options[index] === shade;
    });
  }

  function preferredVariant(variants) {
    // A shade can represent multiple variant combinations. Choose a purchasable
    // combination first, then prefer a variant with its own image.
    return variants.find(v => v.available && v.featured_image) ||
      variants.find(v => v.available) ||
      variants.find(v => v.featured_image) ||
      variants[0];
  }

  function showVariantState(card, variantId) {
    if (!card) return;
    const swatchContainer = card.querySelector('.collectionSwatches');
    const config = swatchContainer && configurations.get(swatchContainer.dataset.id);
    if (!config) return;

    const variant = config.product.variants.find(v => String(v.id) === String(variantId));
    if (!variant) return;

    const form = card.querySelector('.quick-add form[data-type="add-to-cart-form"]');
    if (!form) return;
    const input = form.querySelector('input[name="id"]');
    const button = form.querySelector('button[type="submit"]');
    if (!input || !button) return;

    const soldOut = !variant.available;
    input.value = String(variant.id);
    input.disabled = soldOut;

    if (!originalButtonHTML.has(button)) {
      originalButtonHTML.set(button, button.innerHTML);
    }
    button.disabled = soldOut;
    button.setAttribute('aria-disabled', String(soldOut));
    button.innerHTML = soldOut
      ? '<span class="flex-the-btn">SOLD OUT</span>'
      : originalButtonHTML.get(button);

  }

  function decorate(container) {
    const config = configurations.get(container.dataset.id);
    if (!config || !config.product || !Array.isArray(config.product.variants)) return;
    const swatches = Array.from(container.querySelectorAll('.swatchColor'));
    if (!swatches.length) return;

    const index = Number(config.index) || 0;
    const shadeNames = Array.from(new Set(config.product.variants.map(v => v.options[index])));

    swatches.forEach(function (swatch, position) {
      // Webyze uses product variant order for rendering unique option values.
      const shade = shadeNames[position];
      if (shade === undefined) return;
      const matches = getVariants(config, shade);
      const variant = preferredVariant(matches);
      if (!variant) return;

      const soldOut = !matches.some(v => v.available);
      swatch.dataset.id = String(variant.id); // Fix Webyze's image-dependent variant mapping.
      swatch.dataset.boAvailable = String(!soldOut);
      swatch.classList.toggle('bo-swatch-sold-out', soldOut);
      // Keep the same visible hover label for every shade, regardless of stock.
      // Screen-reader text can additionally communicate availability.
      swatch.title = shade;
      swatch.setAttribute('aria-label', soldOut ? shade + ', sold out' : shade);

      const tooltip = swatch.querySelector('.webyzeTooltip .innerText');
      if (tooltip) tooltip.textContent = shade;

      if (variant.featured_image && variant.featured_image.src) {
        swatch.dataset.image = variant.featured_image.src.replace(
          /\.(jpeg|jpg|gif|png|webp)(\?.*)?$/i, '_large.$1$2'
        );
      }
    });

    const card = container.closest('.product-card-wrapper');
    if (card) {
      const input = card.querySelector('.quick-add form input[name="id"]');
      if (input) showVariantState(card, input.value);
    }
  }

  function decorateAll() {
    document.querySelectorAll('.collectionSwatches.webyzeLoaded').forEach(decorate);
  }

  function queueDecoration() {
    if (decorationQueued) return;
    decorationQueued = true;
    window.requestAnimationFrame(function () {
      decorationQueued = false;
      decorateAll();
    });
  }

  window.loadSwatchesCollection = function (configuration) {
    if (configuration && configuration.product && Array.isArray(configuration.product.variants)) {
      configurations.set(String(configuration.id), configuration);
    }
    const result = originalLoadSwatches.apply(this, arguments);
    queueDecoration();
    return result;
  };

  // The original Webyze delegated click callback updates the hidden input first.
  // Our document listener runs afterward and updates the same card's purchase state.
  document.addEventListener('click', function (event) {
    const swatch = event.target.closest('.collectionSwatches .swatchColor');
    if (!swatch || !swatch.dataset.id) return;
    showVariantState(swatch.closest('.product-card-wrapper'), swatch.dataset.id);
  });

  // Secondary protection against Enter-key or scripted form submissions.
  document.addEventListener('submit', function (event) {
    const form = event.target;
    if (!form.matches || !form.matches('.product-card-wrapper .quick-add form[data-type="add-to-cart-form"]')) return;
    const card = form.closest('.product-card-wrapper');
    const container = card && card.querySelector('.collectionSwatches');
    const config = container && configurations.get(container.dataset.id);
    const input = form.querySelector('input[name="id"]');
    if (!config || !input) return;
    const variant = config.product.variants.find(v => String(v.id) === input.value);
    if (!variant || !variant.available) {
      event.preventDefault();
      event.stopImmediatePropagation();
      showVariantState(card, input.value);
    }
  }, true);

  function initObserver() {
    queueDecoration();
    const observer = new MutationObserver(function (mutations) {
      for (const mutation of mutations) {
        for (const node of mutation.addedNodes) {
          if (node.nodeType === 1 && (
            node.matches('.swatchColor, .collectionSwatches') ||
            node.querySelector('.swatchColor, .collectionSwatches')
          )) {
            queueDecoration();
            return;
          }
        }
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initObserver);
  } else {
    initObserver();
  }
})();
